

















































import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import { dateFormat } from '@/helpers/dateFormat';
import { getUsersTranscriptionChartData, getUsersWrongTranscriptionChartData } from '@/services/dashboard';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, skipWhile, switchMap, tap } from 'rxjs/operators';
import Component from 'vue-class-component';
import { GChart } from 'vue-google-charts/legacy';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    GChart,
    ListMessages,
  },
})
export default class UsersTranscriptionsCharts extends BaseComponent {
  @Prop()
  public dateFrom: string;
  @Prop()
  public dateTo: string;
  @Prop()
  public idsBusinessUnits: number[];

  @Prop({ default: false })
  public wrong: boolean;

  loadingSOcr = false;
  loadingCOcr = false;
  error = false;
  showSOcr = false;
  showCOcr = false;
  private chartDataSOcr: any[] = [];
  private chartDataCOcr: any[] = [];

  private chartOptions = {
    //curveType: 'function',
    backgroundColor: 'transparent',
    /*width: 500,
    height: 300,*/
    chartArea: { left: '200', top: '0', right: '50', bottom: '20' },
    legend: { position: 'none' },
    /*
    hAxis: {
      slantedText: true,
    },
    vAxis: {
      title: null,
      minValue: 0,
    },*/
  };

  private execBehaviorSubSOcr$: BehaviorSubject<any> = new BehaviorSubject(null);
  private execBehaviorSubCOcr$: BehaviorSubject<any> = new BehaviorSubject(null);

  mounted() {
    this.execBehaviorSubSOcr$
      .pipe(
        skipWhile((val) => {
          return val === null;
        }),
        debounceTime(300),
        tap(() => {
          this.loadingSOcr = true;
          this.showSOcr = false;
        }),
        switchMap((filter) => {
          if (this.wrong) {
            return getUsersWrongTranscriptionChartData(filter);
          } else {
            return getUsersTranscriptionChartData(filter);
          }
        }),
      )
      .subscribe(
        (res) => {
          this.chartDataSOcr.push(['Usuário', 'Transcrições', { role: 'style' }, this.columnAnnotation]);
          res.forEach((i) => {
            this.chartDataSOcr.push([i.id, i.valor, `color: ${this.wrong ? 'red' : this.barColor}`, i.valor]);
          });
          this.loadingSOcr = false;
          setTimeout(() => {
            this.showSOcr = true;
          }, 300);
        },
        (error) => {
          this.loadingSOcr = false;
          this.error = true;
        },
      );

    this.execBehaviorSubCOcr$
      .pipe(
        skipWhile((val) => {
          return val === null;
        }),
        debounceTime(300),
        tap(() => {
          this.loadingCOcr = true;
          this.showCOcr = false;
        }),
        switchMap((filter) => {
          if (this.wrong) {
            return getUsersWrongTranscriptionChartData(filter);
          } else {
            return getUsersTranscriptionChartData(filter);
          }
        }),
      )
      .subscribe(
        (res) => {
          this.chartDataCOcr.push(['Usuário', 'Transcrições', { role: 'style' }, this.columnAnnotation]);
          res.forEach((i) => {
            this.chartDataCOcr.push([i.id, i.valor, `color: ${this.wrong ? 'red' : this.barColor}`, i.valor]);
          });
          this.loadingCOcr = false;
          setTimeout(() => {
            this.showCOcr = true;
          }, 300);
        },
        (error) => {
          this.loadingCOcr = false;
          this.error = true;
        },
      );

    this.prepareLoad();
  }

  load() {
    this.loadByType(true, this.chartDataCOcr);
    this.loadByType(false, this.chartDataSOcr);
  }

  columnAnnotation = { calc: 'stringify', sourceColumn: 1, type: 'number', role: 'annotation' };

  loadByType(ocr, array: any[]) {
    array.splice(0, array.length);
    let filtro = this.buildFiltro(ocr);
    if (ocr) {
      this.execBehaviorSubCOcr$.next(filtro);
    } else {
      this.execBehaviorSubSOcr$.next(filtro);
    }
  }

  buildFiltro(ocr) {
    let filtro: any = {};
    filtro.dataDe = this.dateFrom ? dateFormat(this.dateFrom, 'US') : null;
    filtro.dataAte = this.dateTo ? dateFormat(this.dateTo, 'US') : null;
    filtro.usoOcr = ocr;
    filtro.idsEmpresas = this.idsBusinessUnits;

    return filtro;
  }

  @Watch('dateFrom')
  @Watch('dateTo')
  @Watch('idsBusinessUnits')
  public onChangeDates() {
    this.prepareLoad();
  }

  timeoutDatesChange = null;
  public prepareLoad() {
    clearTimeout(this.timeoutDatesChange);
    this.timeoutDatesChange = setTimeout(() => {
      this.load();
    }, 100);
  }
}
